module.exports = __webpack_public_path__ + "5d5d20608f7658c075dc0ac4cd74c90d.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/certificate_yellow.svg
// module id = 2886
// module chunks = 24